import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import {
  ErrorMsgDetail,
  GetItemFullSearchArr,
  fItemCodeDependency,
  GetSearchItem,
  GetUnitArr,
  fValidationDetail_Client,
  fValidationHead_Client,
  //item
  GCToggleSearch_ItemName_Columns,
  GCToggleSearch_ItemName_Select_Arr,

  //save
  fSaveHead,
  fLoad_Grid,
  fSaveApprove,
  GetBatchDispatch,
} from "./Action";
import {
  fAlertToast,
  fcovertToNumber,
  GetCheck_Monthend_DueDate,
  fcheck_null_undefine_replace_empty,
  GetGitterColumns,
  fKeyTabInput,
} from "../../Utility/Utilitys";

import {
  INVBTOUT_batchDispatchDetailDelete_GETROW,
  INVBTOUT_getBatchDispatchVariance_GETROW,
  InventoryPhysicalstock_deleteDetail_API,
  common_locaitonlist_API,
} from "../../Server/ApiV2";
import {
  Set_HeadObj,
  Set_HeadObj_Init,
  Set_HeadObj_DetailHead,
  Set_HeadObj_DetailHead_Date,
  Set_HeadObj_DetailHead_Update,
} from "./SliceBatchOut";
import React, { useState, useEffect, useRef, useCallback } from "react";

import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import Breadcrumbs from "./BreadCrumbs";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";

import "./BatchOut.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import { DetailTblCard } from "./processComponent/DetailTblCard";
import GcHead from "./processComponent/GcHead";
import GcContent from "./processComponent/GcContent";
import { BatchOutRo } from "../../Redux/roStore";

import { useNavigate } from "react-router-dom";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import BatchOut from "./BatchOut";
import { VarianceTblCard } from "./processComponent/VarianceTblCard";
import { CmpTextFieldV1 } from "../../Component/Common/ToolBox/ToolBoxV1";
export default function BatchOutDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BarcodeFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const vRdxHead = useSelector((state) => state.SliceBatchOut.value.HeadObj);
  const vRdxHeadDetail = useSelector(
    (state) => state.SliceBatchOut.value.DetailHead
  );
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const sEnterKeyObj = {
    key: "Enter",
  };

  const fDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_HeadObj_DetailHead_Date({
          DispatchDate1: "",
        })
      );
    } else {
      dispatch(
        Set_HeadObj_DetailHead_Date({
          DispatchDate1: event?.$d,
        })
      );
    }
  };

  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);

  const [sDetail_Grid_Row, setDetail_Grid_Row] = useState([]);
  const sRoundingVal = 4;
  const fDetail_Grid_onRowClick = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      DP_SrNo: item.row.DP_SrNo,
      DP_Batch: item.row.DP_Batch,
      DP_ItmCd: item.row.DP_ItmCd,
      ItmName: item.row.ItmName,
      DP_Qty: item.row.DP_Qty,
      DP_Unit: item.row.DP_Unit,
      UnitName: item.row.UnitName,
      DP_BaseQty: item.row.DP_BaseQty,
    }));
    let resp = await GetBatchDispatch(item.row.DP_Batch, sBufferObj);

    if (resp.stockDetails.length > 0) {
      setBufferObj((obj) => ({
        ...obj,
        TransQty: resp?.transactionDetails[0]?.TransQty,
        AllocQty: resp?.transactionDetails[0]?.AllocQty,
        BacthQty: resp?.stockDetails[0]?.BaseQty,
        ResQty: resp?.stockDetails[0]?.Reserved,
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        TransQty: 0,
        AllocQty: 0,
        BacthQty: 0,
        ResQty: 0,
      }));
    }

    let currentUnitArr = await GetUnitArr(item.row.DP_ItmCd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.DP_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      DP_Unit: vUnitvalue?.Unit,
      UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue?.PackDesc,
    }));
    // fCloseViewModal();

    document.getElementsByName("DP_Qty")[0].focus();
  };

  let vBufferObjInit = {
    DP_SrNo: 0,
    DP_Batch: "",
    DP_ItmCd: "",
    ItmName: "",
    DP_Qty: 0, // Assuming quantity is numeric
    DP_Unit: "",
    UnitName: "",
    DP_BaseQty: 0, // Assuming base quantity is numeric
    B_PackQty: 0,
    B_Packing: 0,
    BacthQty: "",
    ResQty: "",
    BalQty: "",
    TransQty: "",
    AllocQty: "",
    BalalanceQty: "",
  };

  const [sBufferObj, setBufferObj] = useState(vBufferObjInit);

  const [sUnit, setUnit] = useState([]);
  const fContent_Focus = (e) => {
    if (Number(e.target.value) === 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value === "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };
  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      DP_Unit: vUnitvalue?.Unit,
      UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue?.PackDesc,
    }));
  };

  const fQty_Enter = (e) => {
    if (e.key === "Enter") {
      fSave();
      document.getElementsByName("DP_Qty")[0].blur();
    }
  };
  const fBatch = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      DP_Batch: e.target.value,
    }));
  };
  const fBatch_BackSpace_Clear = () => {
    setBufferObj((obj) => ({
      ...obj,
      DP_ItmCd: "",
      ItmName: "",

      DP_Unit: "",
      UnitName: "",
      DP_BaseQty: 0,
      BacthQty: "",
      ResQty: "",
      BalQty: "",
      TransQty: "",
      AllocQty: "",
      BalalanceQty: "",
    }));
    setUnit([]);
  };

  //API NOTIFICATION_PICKINGBarcodeSEARCH_GETROW
  const GetBatchDetail = async (xBatch) => {
    let item = await GetBatchDispatch(xBatch, sBufferObj);

    if (item.stockDetails.length > 0) {
      setBufferObj((obj) => ({
        ...obj,
        DP_ItmCd: item?.stockDetails[0]?.ItmCd,
        ItmName: item?.stockDetails[0]?.ItmName,
        TransQty: item?.transactionDetails[0]?.TransQty,
        AllocQty: item?.transactionDetails[0]?.AllocQty,
        BacthQty: item?.stockDetails[0]?.BaseQty,
        ResQty: item?.stockDetails[0]?.Reserved,
      }));
      let currentUnitArr = await GetUnitArr(
        item?.stockDetails[0]?.ItmCd,
        setUnit
      );

      if (currentUnitArr.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          DP_Unit: currentUnitArr[0].Unit,
          UnitName: currentUnitArr[0].Name1,
          B_PackQty: currentUnitArr[0].PackQty,
        }));
      }
      setTimeout(() => {
        document.getElementsByName("DP_Qty")[0].focus();
      }, 500);
    } else {
      fAlertToast("FAILED", "Wrong  ItemCode");
    }
  };

  const fBatchEnter = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      if (sBufferObj.DP_Batch === "") {
        fAlertToast("FAILED", "Batch is empty");
      } else {
        await GetBatchDetail(sBufferObj.DP_Batch);
      }
    } else if (e.key === "Backspace") {
      fBatch_BackSpace_Clear();
    }
  };

  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fClearErrorMsg();
    timeout = setTimeout(async () => {
      if (vRdxHead?.Status !== "ENTER") {
        fAlertToast("FAILED", "Not allowed in " + vRdxHead?.Status + " mode");
        return;
      }

      let validation = fValidationHead_Client(vRdxHead);

      if (!validation) return;

      let validationDetil = fValidationDetail_Client(
        sBufferObj,
        setErrorMsgDetail
      );

      if (!validationDetil) return;

      fSaveHead(fNewDetail, sBufferObj, dispatch);
    }, 500);
  };
  const GetVariance = async () => {
    let { HeadObj } = BatchOutRo();
    let vVarianceObj = {
      v_TrnTyp: HeadObj.TrnTyp,
      v_VocTyp: HeadObj.A_VocTyp,
      v_VocNo: HeadObj.A_VocNo,
      v_Loc: HeadObj.A_Loc,
    };
    const vVariance = await INVBTOUT_getBatchDispatchVariance_GETROW(
      vVarianceObj
    );
    if (vVariance?.status === 200) {
      let GridID = vVariance?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridVarienceRow(GridID);
    }
    setVariance(true);
  };
  const fVariance = async (e) => {
    await GetVariance();
  };
  const fApprove = async (e) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.DP_ItmCd !== "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetail_Grid_Row.length === 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }
      let validation = fValidationHead_Client(vRdxHead);

      if (!validation) return;

      fSaveApprove(fNewDetail, navigate);
    }, 500);
  };

  const fClearErrorMsg = () => {
    setErrorMsgDetail(ErrorMsgDetail);
  };

  const fNew = async () => {
    fClearErrorMsg();
    fNewDetail();

    // if (sBufferObj.ItmName === "") {
    //   fNewHead();
    //   fNewDetail();
    //   document?.getElementsByName("DispatchDate1")[0]?.focus();
    // } else {
    //   fNewDetail();
    // }
  };
  //Modal View
  const [sViewModal, setViewModal] = useState(false);

  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };
  //Modal View
  const [sSummaryModal, setSummaryModal] = useState(false);
  const [sVariance, setVariance] = useState(false);
  const [sGridVarienceRow, setGridVarienceRow] = useState([]);

  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  const fNewHead = async () => {
    dispatch(Set_HeadObj_Init()); // Head Clearing

    // Setting Initial List Box 0th Object
    dispatch(
      Set_HeadObj_DetailHead({
        Version: 0,
        DispatchDate1: new Date(),
      })
    );
    setDetail_Grid_Row([]);
    setBufferObj(vBufferObjInit);
  };

  //vTaxType  vTaxType ==  sTax[1].Uid then tax %0
  const fNewDetail = () => {
    setBufferObj(vBufferObjInit);

    setUnit([]);

    fLoad_Grid(setDetail_Grid_Row);

    document.getElementsByName("DP_Batch")[0]?.focus();
  };

  const fDelete = (e) => {
    if (vRdxHead.Status === "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    } else if (sBufferObj.DP_SrNo === 0) {
      fAlertToast("FAILED", "Item not selected");
      return;
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async () => {
    const { HeadObj } = BatchOutRo();
    const { DetailHead } = BatchOutRo();
    let vDeleteSIDetailObj = {
      v_B_TrnTyp: HeadObj.TrnTyp,
      v_B_VocTyp: HeadObj.A_VocTyp,
      v_B_VocNo: HeadObj.A_VocNo,
      v_B_Srno: sBufferObj.DP_SrNo,
      v_B_Loc: HeadObj.A_Loc,
      v_B_Version: DetailHead.Version,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await INVBTOUT_batchDispatchDetailDelete_GETROW(
      FinalObj
    );

    if (vDeleteSIDetail?.status === 200) {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail();
    }
  };
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      const { HeadObj } = BatchOutRo();
      const { DetailHead } = BatchOutRo();
      // http://localhost:63212/WMS/DOBatchOut?Trntyp=INV08&VocTyp=SI036&VocNo=SICKM76505&Loc=21&Version=1&Prntyp=DISBATCH
      let urlPrint =
        vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val +
        "WMS/DOBatchOut?Prntyp=" +
        xPrnTyp +
        "&VocTyp=" +
        HeadObj.A_VocTyp +
        "&VocNo=" +
        HeadObj.A_VocNo +
        "&Version=" +
        DetailHead.Version +
        "&Trntyp=" +
        HeadObj.TrnTyp +
        "&Loc=" +
        HeadObj.A_Loc;
      console.log(urlPrint);
      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [vRdxDBKernObj]
  );

  //esc keyZ close item dropdown

  useEffect(() => {
    setBufferObj((obj) => ({
      ...obj,
      DP_BaseQty: fcovertToNumber(sBufferObj.DP_Qty * sBufferObj.B_PackQty),
    }));
  }, [sBufferObj.DP_Qty, sBufferObj.B_PackQty]);
  useEffect(() => {
    setBufferObj((obj) => ({
      ...obj,
      BalQty: fcovertToNumber(sBufferObj.BacthQty - sBufferObj.ResQty),
    }));
  }, [sBufferObj.BacthQty, sBufferObj.ResQty]);
  useEffect(() => {
    setBufferObj((obj) => ({
      ...obj,
      BalalanceQty: fcovertToNumber(sBufferObj.TransQty - sBufferObj.AllocQty),
    }));
  }, [sBufferObj.TransQty, sBufferObj.AllocQty]);

  // const getLocation = useCallback(async () => {
  //   let locationObj = {
  //     usercd: vRdxuserInfo.UserID,
  //   };
  //   let locationList = await common_locaitonlist_API(locationObj);
  //   if (locationList?.status === 200) {
  //     if (locationList.data?.ResultSet?.length > 0) {
  //       setLocation(locationList?.data?.ResultSet);
  //     }
  //   }
  // }, [vRdxuserInfo.UserID]);

  // useEffect(() => {
  //   getLocation();
  // }, [getLocation]);

  useEffect(() => {
    fLoad_Grid(setDetail_Grid_Row);
  }, []);

  useEffect(() => {
    BarcodeFocusOnLoad?.current?.focus();
  }, []);
  const [Detail_Grid_columns, setGridDataAuditColumns] = useState([
    {
      field: "DP_SrNo",
      headerName: "Sr No",
      width: 50,
      hide: vMediaQuery ? true : false,
    },
    {
      field: "DP_Batch",
      headerName: "Batch",
      width: 150,
    },

    {
      field: "DP_Qty",
      headerName: "Qty",
      width: 50,
    },
    {
      field: "DP_ItmCd",
      headerName: "Item Code",
      width: 90,
      hide: true,
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 320,
    },

    {
      field: "UnitName",
      headerName: "Unit",
      width: 100,
    },
    {
      field: "DP_BaseQty",
      headerName: "Base Qty",
      width: 100,
      hide: vMediaQuery ? true : false,
    },
  ]);

  // useEffect(() => {
  //   GetGitterColumns(
  //     setGridDataAuditColumns,
  //     "WMS_SALES_INVOICE_AUDIT",
  //     Detail_Grid_columns
  //   );

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  return (
    <div className="container-fluid ">
      <div className="Breadcrumbs">
        <Breadcrumbs />
      </div>
      <div className="BatchOut-detail">
        {vMediaQuery ? (
          ""
        ) : (
          // <WmsHead
          //   xref={BarcodeFocusOnLoad}
          //   vRdxHead={vRdxHead}
          //   xErrorMsg={sErrorMsg}
          //   vRdxuserLoc={sLocation}
          //   fLocation={fLocation}
          //   fReferenceNo={fReferenceNo}
          //   fReferenceNo_Enter={fReferenceNo_Enter}
          //   fDate={fDate}
          //   sDetail_Grid_Row={sDetail_Grid_Row}
          // />
          <GcHead
            vRdxHead={vRdxHead}
            fDate={(event) => {
              dispatch(
                Set_HeadObj_DetailHead_Update({
                  ...vRdxHeadDetail,
                  DeptDate1: event?.$d,
                })
              );
            }}
            sDetail_Grid_Row={sDetail_Grid_Row}
            fKeyTabInput={fKeyTabInput}
            vRdxHeadDetail={vRdxHeadDetail}
          />
        )}
        <GcContent
          BarcodeFocusOnLoad={BarcodeFocusOnLoad}
          xBufferObj={sBufferObj}
          xErrorMsgDetail={sErrorMsgDetail}
          xMediaQuery={vMediaQuery}
          onChnage={(e) => {
            setBufferObj((obj) => ({
              ...obj,
              [e.target.name]: e.target.value,
            }));
          }}
          sUnit={sUnit}
          fUnit={fUnit}
          fBatch={fBatch}
          fBatchEnter={fBatchEnter}
          fQty_Enter={fQty_Enter}
          xContent_Focus={fContent_Focus}
          xContent_Blur={fContent_Blur}
        />

        {/* <WmsContent
          sEnterKeyObj={sEnterKeyObj}
          xContent_Focus={fContent_Focus}
          xContent_Blur={fContent_Blur}
          xErrorMsgDetail={sErrorMsgDetail}
          xBufferObj={sBufferObj}
          sUnit={sUnit}
          fUnit={fUnit}
          fQty={fQty}
          fQty_Enter={fQty_Enter}
          fBarcode={fBarcode}
          fBarcodeEnter={fBarcodeEnter}
          //GC toggle
          fItemName={GCToggleSearch_ItemName_Main_Input} //onchange main input
          xMediaQuery={vMediaQuery} //mobile screen
          xonClickbtn={GCToggleSearch_ItemName_Main_Enter} // onclick icon open div on main screen
          xrows={GCToggleSearch_ItemName_Grid_Row} //Grid Row GCToggle Search from API
          xcolumns={GCToggleSearch_ItemName_Columns} //GCToggleSearch-Grid col GCToggle Search fron Action
          xRowCellClick={GCToggleSearch_ItemName_CellClick} //GCToggleSearch-grid clic
          xRowClick={GCToggleSearch_ItemName_RowClick} //GCToggleSearch- grid click
          xToggle={GCToggleSearch_ItemName_Toggle} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
          xData={GCToggleSearch_ItemName_Select_Arr} // GCToggleSearch-select-tag arr
          xOnChangeDropdownInput={GCToggleSearch_ItemName_Sub_Input} //GCToggleSearch-input search onchane DATA/TYPE
          xDropdownObj={GCToggleSearch_ItemName_Obj} // GCToggleSearch-object DATA/TYPE
          xOnKeyUpDropdownInput={GCToggleSearch_ItemName_Sub_Enter} //GCToggleSearch-
        /> */}
        <Grid
          container
          className="my-2"
          spacing={{ xs: 1, sm: 1, md: 0 }}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          sx={{
            alignItems: "center",
            justifyContent: vMediaQuery ? "start" : "center",
            textAlign: "center",
          }}
        >
          <Grid item xs={4} sm={4} md={2} lg={2}>
            <CmpButton
              xbtnName="New"
              xOnClick={fNew}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xId={"IdNew"}
              xSendIcon={<AddBoxRoundedIcon />}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={2} lg={2}>
            <CmpButton
              xbtnName="Save"
              xOnClick={fSave}
              xVariant="contained"
              xDisabled={vRdxHeadDetail.Status !== "ENTER"}
              xSize="small"
              xId={"IdSave"}
              xSendIcon={<SaveRoundedIcon />}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={2} lg={2}>
            <CmpButton
              xbtnName="Delete"
              xOnClick={fDelete}
              xVariant="contained"
              xDisabled={vRdxHeadDetail.Status !== "ENTER"}
              xSize="small"
              xId="IdDelete"
              xSendIcon={<DeleteRoundedIcon />}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={2} lg={2}>
            <CmpButton
              xbtnName="Approve"
              xOnClick={fApprove}
              xVariant="contained"
              xDisabled={vRdxHeadDetail.Status !== "ENTER"}
              xSize="small"
              xId="IdDelete"
              xSendIcon={<CheckCircleOutlineRoundedIcon />}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={2} lg={2}>
            <CmpButton
              xbtnName="Variance"
              xOnClick={fVariance}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xId="IdDelete"
              // xSendIcon={<CheckCircleOutlineRoundedIcon />}
            />
          </Grid>

          {/* <Grid
            item
            xs={4}
            sm={4}
            md={2.2}
            lg={2.2}
            className="xs-dontShowInMobileView"
          >
            <CmpButton
              xbtnName="Approve"
              xOnClick={fApprove}
              xVariant="contained"
              xDisabled={vRdxHead.Status !== "ENTER"}
              xSize="small"
              xId={"IdApprove"}
              xSendIcon={<CheckCircleOutlineRoundedIcon />}
            />
          </Grid> */}

          <Grid item xs={4} sm={4} md={2} lg={2} className="xs-screen-hide">
            <DropdownButton
              id="dropdown-basic-button"
              title="Print"
              variant="primary"
              size="xs"
            >
              <Dropdown.Item
                id="IdPrint"
                onClick={(e) => {
                  fPrint("DISBATCH");
                }}
              >
                Dispatch
              </Dropdown.Item>
              <Dropdown.Item
                onClick={(e) => {
                  fPrint("DISBATCHDO");
                }}
              >
                Delivey Note
              </Dropdown.Item>
            </DropdownButton>
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={2.2}
            lg={2.2}
            className="bintransfer-btn-grid-sm-show"
          >
            <CmpButton
              xbtnName="Detail"
              xOnClick={fView}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xSendIcon={<RemoveRedEyeIcon />}
            />
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={2.2}
            lg={2.2}
            className="bintransfer-btn-grid-sm-show"
          >
            <CmpButton
              xbtnName="Summary"
              xOnClick={fSummary}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xSendIcon={<RemoveRedEyeIcon />}
            />
          </Grid>
        </Grid>
        {!vMediaQuery ? (
          <div className="mt-1 xs-screen-hide">
            <Box sx={{ height: "45vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetail_Grid_Row}
                columns={Detail_Grid_columns}
                hideFooter={sDetail_Grid_Row.length < 100}
                onRowClick={fDetail_Grid_onRowClick}
                // components={{
                //   Toolbar: vMediaQuery ? "" : GridToolbar,
                // }}
              />
              {/* <DetailTblCard
              data={sDetail_Grid_Row}
              onClick={fDetail_Grid_onRowClick}
            /> */}
            </Box>
          </div>
        ) : (
          <>
            {sDetail_Grid_Row.length > 0 && (
              <DetailTblCard
                data={sDetail_Grid_Row}
                onClick={fDetail_Grid_onRowClick}
              />
            )}
          </>
        )}
      </div>
      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Detail"} onClose={fCloseViewModal} />

          <div className="py-3">
            <div style={{ height: "69vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetail_Grid_Row}
                columns={Detail_Grid_columns}
                hideFooter={sDetail_Grid_Row.length < 100}
                onRowClick={fDetail_Grid_onRowClick}
                // components={{
                //   Toolbar: vMediaQuery ? "" : GridToolbar,
                // }}
              />
            </div>
          </div>
        </Box>
      </Modal>

      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary"} onClose={fCloseSummaryModal} />

          <div className="py-3">
            <GcHead
              vRdxHead={vRdxHead}
              fDate={(event) => {
                dispatch(
                  Set_HeadObj_DetailHead_Update({
                    ...vRdxHeadDetail,
                    DeptDate1: event?.$d,
                  })
                );
              }}
              sDetail_Grid_Row={sDetail_Grid_Row}
              fKeyTabInput={fKeyTabInput}
              vRdxHeadDetail={vRdxHeadDetail}
            />
          </div>
        </Box>
      </Modal>
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
      <Modal
        open={sVariance}
        onClose={() => {
          setVariance(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky
            title={"Variance"}
            onClose={() => {
              setVariance(false);
            }}
          />

          <div>
            {/* <div className="d-flex justify-content-end">
              <CloseIcon onClick={fCloseInstantPickingVarianceModel} />
            </div> */}
            <div className="p-2">
              <Grid container spacing={2} className="align-items-center mb-1">
                <Grid item xs={12} md={2} className="bintransfer-data-date">
                  <CmpTextFieldV1
                    xLabelText="Voc.No"
                    xValue={vRdxHead?.A_VocNo}
                    xType={"text"} // text/number/password
                    xName={"A_VocNo"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    // xOnKeyUp={xKey}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <CmpTextFieldV1
                    xLabelText="Document"
                    xValue={vRdxHead?.VocName}
                    xType={"text"} // text/number/password
                    xName={"LocName"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    // xOnKeyUp={xKey}
                  />
                </Grid>
              </Grid>
              {/* <Box style={{ height: "60vh", width: "100%" }}>
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  getRowId={(row) => row.id}
                  rows={sGridVarienceRow}
                  columns={[
                    {
                      field: "B_ItmCd",
                      headerName: "Item Code",
                      width: 120,
                    },
                    {
                      field: "ItmName",
                      headerName: "Item Name",
                      width: 250,
                    },
                    // {
                    //     field: 'picked',
                    //     headerName: 'Picked',
                    //     width: 80,
                    // },
                    {
                      field: "B_Qty",
                      headerName: "Trans.Qty",
                      width: 100,
                    },
                    {
                      field: "DP_Qty",
                      headerName: "Batch Qty",
                      width: 100,
                    },
                    {
                      field: "QtyDiff",
                      headerName: "Difference",
                      width: 100,
                    },
                  ]}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  hideFooter={sGridVarienceRow.length < 100}
                />
              </Box> */}
              {sGridVarienceRow.length > 0 && (
                <VarianceTblCard data={sGridVarienceRow} onClick={() => {}} />
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
